module.exports = __webpack_public_path__ + "img/newspaper.9821397.svg";